import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { getCardType } from '@/core/payment-card/utilities/card';
import CardIcon from '@/core/payment-card/components/card-icon';
import { DEFAULT_CARD_TYPE_NAME } from '@/core/payment-card/constants/card-types';

@Component({
    data() {
        return {
            number: null,
            immediateValidation: false,
            snackbar: false
        };
    },
    components: {
        ValidationProvider,
        CardIcon
    },
    inheritAttrs: false
})
export default class CardNumber extends Vue {
    @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;
    @Ref() readonly cardNumberInput!: HTMLElement;

    @Prop()
    value: string;

    @Prop()
    label: string;

    @Prop()
    placeholder: string;

    // The name was changed to cardInput to prevent browser autofill
    @Prop({ default: 'cardInput' })
    inputName: string;

    @Prop({ type: Array, default: [] })
    unsupportedCardTypes: Array<string>;

    @Prop()
    validationMode: string;

    @Prop({ type: Array, default: [] })
    supportedCards: Array<string>;

    @Prop()
    errorMessage: string;

    @Prop({ type: String, default: '#06A9BF' })
    checkColor: string;

    @Prop(Boolean)
    hideSupportedCards: boolean;

    @Prop()
    brand: string;

    number;
    immediateValidation: boolean;
    snackbar: boolean;

    created() {
        this.number = this.value;
    }

    get cardType() {
        return getCardType(this.number);
    }

    get supportedKnownCards() {
        return this.supportedCards?.filter((card) => card !== DEFAULT_CARD_TYPE_NAME);
    }

    unmasked(value) {
        return value?.replace(/ /g, '');
    }

    @Watch('number')
    change(value) {
        this.$emit('input', this.unmasked(value));
    }

    @Watch('value', { immediate: true })
    onChangeValue(value: string) {
        if (value) {
            this.immediateValidation = true;
        }
    }

    toggleSnackbar() {
        this.snackbar = !this.snackbar;

        this.$nextTick(() => {
            this.cardNumberInput.blur();
        });
    }

    async validate() {
        await this.provider.validate();
        this.$emit('validate', this.unmasked(this.number));
    }
}
